import React from "react";

const FooterBottom = () => {
  return (
    <div className="bg-[#D23431] text-white md:px-16  py-5  md:text-lg text-center md:text-left font-Montserrat-Light">
      <div className="max-w-7xl mx-auto">
        All Rights Reserved Nerdy Eye Powered By Dungada Tech Ltd.
      </div>
    </div>
  );
};

export default FooterBottom;
